__turbopack_context__.v({
  "actions": "ErrorFallback-module__sENzLG__actions",
  "fullPage": "ErrorFallback-module__sENzLG__fullPage",
  "message": "ErrorFallback-module__sENzLG__message",
  "title": "ErrorFallback-module__sENzLG__title",
  "wrap": "ErrorFallback-module__sENzLG__wrap",
});
